export default __webpack_public_path__ + "static/media/sanmar9.990fa33e.jpg";